 {
    "common": {
    "thisWeek": "Esta semana",
    "lastWeek": "Semana passada",
    "lastNumberOfDays": "Últimos {numberOfDays} dias",
    "thisMonth": "Este mês"
    },
    "subAccounts": "Subcontas",
    "submitFeedback": "Envie feedback",
    "createSubAccount": "Criar subconta",
    "viewScheduleReports": "Visualizar relatórios programados",
    "searchSubAccount": "Pesquisar por subconta",
    "columns": "Colunas",
    "sortBy": "Ordenar por",
    "selectColumns": "Selecionar colunas",
    "maxColumns": "Máximo de 8 colunas em um dado",
    "applyColumns": "Aplicar colunas",
    "activeUsers": "Usuários ativos",
    "appointments": "Compromissos",
    "contacts": "Contatos",
    "emails": "Gmail",
    "textMessages": "Mensagens do corpo",
    "calls": "Ligações",
    "submissions": "Envios",
    "reviews": "Avaliações",
    "sitesCreated": "Sites criados",
    "name": "Nome",
    "formSubmissions": "Envios de formulários",
    "surveySubmissions": "Envio de pesquisas",
    "facebookFormSubmissions": "Envios de formulários do Facebook",
    "funnels": "Funis",
    "websites": "Sites",
    "forms": "Formulários",
    "surveys": "Pesquisas",
    "highestFirst": "Máximo primeiro",
    "lowestFirst": "Começar pelo menor",
    "orderBy": "Ordenar Via",
    "noMoreLocations": "Nenhum endereço mais encontrado",
    "preparingReport": "Estamos preparando seu relatório…",
    "preparingReportDesc": "Não feche nem recarregue esta janela enquanto a exportação estiver em andamento.",
    "outOf": "De",
    "subAccountsExported": "Subcontas exportadas",
    "close": "Fechar",
    "scheduledForDeletion": "Programado para exclusão",
    "readyToSell": "Pronto para vender",
    "closedWon": "Fechado (conquistado)",
    "wpSaleSuccessful": "A venda do WordPress foi bem-sucedido",
    "wpNotSold": "O WordPress ainda não foi vendido",
    "yxtSaleSuccessful": "A venda do Yext é sucesso",
    "yxtNotSold": "Yext ainda não foi vendido",
    "saasSubInactive": "SaaS Assinatura é inativo",
    "saasSubTrialing": "SaaS Assinatura está em teste",
    "saasSubActive": "SaaS Assinatura é Dinâmico",
    "emailRebillingActive": "O refaturamento de e-mail é Dinâmico",
    "emailRebillingInactive": "O refaturamento de e-mail é inativo",
    "twilioRebillingActive": "O refaturamento Twilio é Dinâmico",
    "twilioRebillingInactive": "O refaturamento Twilio é inativo",
    "wpRebillingActive": "O refaturamento do WhatsApp está ativo",
    "wpRebillingInactive": "O refaturamento do WhatsApp está inativo",
    "saasModeActivated": "O modo SaaS está Habilitado",
    "paymentPending": "O pagamento está pendente",
    "saasModeNotActivated": "O modo SaaS não é Habilitado",
    "managedByLCPhone": "Gerenciar Via LC Telefone",
    "migrationToLCPhone": "Em migração para o Telefone LC",
    "notManagedByLCPhone": "Não gerenciar Via LC Telefone",
    "managedByLCEmail": "Gerenciar o LeadConnector Email System",
    "notMangedByLCEmail": "Não gerenciar Via LeadConnector Email System",
    "remainingWalletBalance": "Saldo restante da carteira desta localização SaaS",
    "reports": "Relatórios",
    "switchToSubAccount": "Alternar para subconta",
    "manageClient": "Gerenciar cliente",
    "subAccountDeletedIfChangedMind": "Esta subconta será apagada em {time}, se você mudou de ideia",
    "subAccountDeletedInMinute": "Esta subconta será apagada dentro de um minuto",
    "changedMind": "Se Você tem Dinâmico sua mente",
    "clickHere": "clicar aqui",
    "subAccountPaused": "Esta subconta está pausada. Seus clientes não podem fazer login, mas a agência pode. Para retomar esta conta",
    "subAccountRestricted": "Esta subconta está pausada devido à aprovação pendente.",
    "subAccountVerificationPending": "Esta subconta está pausada devido à verificação pendente de e-mail e telefone do administrador da subconta.",
    "subAccountDeclined": "Esta subconta está pausada devido a uma solicitação de aprovação recusada. Você ainda pode retomar esta subconta a partir ",
    "here": "aqui.",
    "reviewAndResume": "para revisar e retomar esta subconta.",
    "incomingCalls": "Ligações recebidas",
    "outgoingCalls": "Ligações efetuadas",
    "totalTalktime": "Tempo de conversa Total",
    "incomingEmails": "Gmailrecebido",
    "outgoingEmails": "Gmailenviado",
    "incomingSms": "Mensagens recebidas do Corpo",
    "outgoingSms": "Mensagens enviadas do Corpo",
    "contactsCreated": "Total de contatos criados",
    "appointmentsBooked": "Total de compromissos agendados",
    "totalFormSubmissions": "Total de envios de formulários",
    "totalSurveySubmissions": "Total de envios de pesquisas",
    "totalFacebookFormSubmissions": "Total de envios de formulários do Facebook",
    "incomingGMBMessages": "Mensagens GBP recebidas",
    "outgoingGMBMessages": "Mensagens GBP enviadas",
    "gmbMessages": "Mensagens GBP",
    "fbMessages": "Mensagens do Facebook",
    "incomingFbMessages": "Mensagens recebidas do Facebook",
    "outgoingFbMessages": "Mensagens enviadas do Facebook",
    "igMessages": "Mensagens do Instagram",
    "incomingIgMessages": "Mensagens recebidas do Instagram",
    "outgoingIgMessages": "Mensagens enviadas do Instagram",
    "totalReviews": "Total de avaliações",
    "positiveReviews": "Avaliações Positivas",
    "negativeReviews": "Avaliações Negativas",
    "back": "Voltar",
    "selectDashboards": "Selecionar painéis",
    "next": "Seguinte",
    "backToSubAccounts": "Voltar para as subcontas",
    "pauseSchedule": "Pausar programação",
    "resumeSchedule": "Continuar programação",
    "editSchedule": "Editar programação",
    "addSchedule": "Adicionar programação",
    "selectReportToAdd": "Selecionar relatórios para Incluir in e-mail",
    "selectAll": "selecionar todos",
    "pauseScheduleConfirm": "Tem certeza de que deseja pausar a programação do relatório?",
    "resumeScheduleConfirm": "Tem certeza de que deseja continuar a programação do relatório?",
    "tasks": "Tarefas",
    "conversations": "Conversas",
    "users": "Usuário",
    "dealOverview": "Visão geral do Acordo",
    "confirmAction": "Confirmar ação",
    "yes": "Sim",
    "no": "Não",
    "reportDetails": "Detalhes do relatório",
    "reportCreatedOn": "Relatório criado ativado",
    "searchByEmail": "Pesquisar por e-mail",
    "lastActivity": "Última atividade",
    "noRecords": "Nenhum registro encontrado",
    "scheduleReport": "Programar relatório",
    "schedule": "programação",
    "save": "Salvar",
    "emailSubject": "Linha de assunto",
    "frequency": "Frequência",
    "daily": "Diário",
    "weekly": "Semanalmente",
    "monthly": "Mensalmente",
    "nextScheduleDate": "Próximo programação Dados",
    "startingOn": "Começando ativado",
    "timeOfDay": "Data de dia",
    "reportsToTimezone": "O relatório será enviado no fuso horário da subconta",
    "selectRecipients": "Selecionar destinatários",
    "invalidEmail": "Insira um endereço de e-mail válido.",
    "testEmail": "E-mail de Testar",
    "selectTestRecipients": "selecionar destinatários Testar",
    "setupSubject": "Configuração do assunto acima para Testar o relatório",
    "sendTest": "Carregar Testar",
    "scheduleSimilarSchedules": "Agendar relatório semelhante para outras subcontas",
    "accountSummary": "Resumo da conta",
    "scheduleList": "Lista de programação",
    "subAccountName": "Nome da subconta",
    "nextRunDate": "Próxima data de execução",
    "reportSectionsAdded": "Segmentos do relatório adicionados",
    "status": "Status",
    "scheduleAction": "Programar ação",
    "cancel": "Cancelar",
    "pleaseWait": "Carregando…",
    "confirm": "Confirmar",
    "booked": "Agendado",
    "confirmed": "Confirmado",
    "showed": "Comparecido",
    "noShow": "Não comparecimento",
    "cancelled": "Cancelado",
    "unread": "Não lido",
    "engagement": "Engajamento",
    "reaction": "Reação",
    "deliverySummary": "Resumo da entrega",
    "successfulDelivery": "Entrega realizada com sucesso",
    "opened": "Aberto",
    "clicked": "Clicado",
    "replied": "Respondidas",
    "unsubscribed": "Inscrição cancelada",
    "complained": "Reclamou",
    "failed": "Falhou",
    "bounced": "Rejeitado",
    "open": "Abrir",
    "won": "Ganho",
    "abandoned": "Abandonado",
    "lost": "Perdido",
    "sent": "Enviado",
    "eject": "Ejetar",
    "delivered": "Entregue",
    "faceBookLeadForm": "Formulário de lead do Facebook",
    "overdue": "Atrasada",
    "reviewsReceived": "Avaliações recebidas",
    "formBuilders": "Construtores de formulários",
    "switchToSaaS": "Mudar para SaaS",
    "numberOfContacts": "Total de contatos",
    "numberOfAppointments": "Total de compromissos",
    "outreach": "Contato",
    "notSubAccountUser": "Não é um usuário da subconta",
    "searchSubAccName": "Pesquisar por nome de subconta",
    "recipients": "Destinatários",
    "scheduleCreated": "Programação de relatórios por e-mail criada para ",
    "scheduleUpdated": "Programação de relatórios por e-mail atualizada para ",
    "scheduleNotCreated": "Não foi possível criar a programação de relatórios por e-mail para",
    "scheduleNotUpdated": "Não foi possível atualizar a programação de relatórios por e-mail para",
    "total": "Total",
    "inbound": "Recebidas",
    "outbound": "Enviadas",
    "totalEmails": "Total de e-mails",
    "inboundEmails": "E-mails recebidos",
    "outboundEmails": "E-mails enviados",
    "totalTextMessages": "Total de mensagens de texto",
    "inboundTextMessages": "Mensagens de texto recebidas",
    "outboundTextMessages": "Mensagens de texto enviadas",
    "totalCalls": "Total de chamadas",
    "inboundCalls": "Chamadas recebidas",
    "outboundCalls": "Chamadas realizadas",
    "faceBookLeadFormSubmissions": "Envios de formulários de lead do Facebook",
    "inboundGMBMessages": "Mensagens GBP recebidas",
    "outboundGMBMessages": "Mensagens GBP enviadas",
    "totalIgMessages": "Total de mensagens do Instagram",
    "inboundIgMessages": "Mensagens recebidas do Instagram",
    "outboundIgMessages": "Mensagens enviadas do Instagram",
    "totalfbMessages": "Total de mensagens do Facebook",
    "inboundfbMessages": "Mensagens recebidas do Facebook",
    "outboundfbMessages": "Mensagens enviadas do Facebook",
    "sitesCreatedFunnels": "Sites criados - funis",
    "sitesCreatedActiveFunnels": "Sites criados - funis ativos",
    "sitesCreatedWebsites": "Sites criados - Sites",
    "sitesCreatedActiveWebsites": "Sites criados - websites ativos",
    "sitesCreatedForms": "Sites criados - formulários",
    "sitesCreatedActiveForms": "Sites Criados - formulários ativos",
    "sitesCreatedSurveys": "Sites criados - pesquisas",
    "sitesCreatedActiveSurveys": "Sites Criados - pesquisas ativas",
    "googleReviews": "Avaliações do Google",
    "facebookReviews": "Avaliações do Facebook",
    "inboundCallDuration": "Duração da chamada de entrada (horas)",
    "outboundCallDuration": "Duração da chamada de saída (horas)",
    "pleaseSelect": "Selecionar",
    "subAccountIsDeleted": "Esta subconta foi excluída",
    "subAccountIsPaused": "Esta subconta foi pausada",
    "success": "Sucesso",
    "error": "Erro",
    "testEmailSent": "E-mail de Testar enviado",
    "testEmailNotSent": "O e-mail do Testar não pôde ser enviado",
    "reviewRequest": "Solicitação de avaliação",
    "pendingTransferDescription": "Outras agências solicitaram a transferência de subcontas para você.",
    "pendingTransferHeading": "Você tem solicitações de transferência de subconta pendentes.",
    "subAccountTransfer": "Transferências de subconta",
    "manageSubAccTransfer": "Gerencie suas solicitações de transferência de subconta",
    "subAccRequest": "Solicitações da subconta {tabName}",
    "receive": "Herdar",
    "send": "Enviar",
    "release": "Versão",
    "requests": "{count} solicitações",
    "subAccLimit": "O limite de uso de subcontas foi atingido.",
    "subAccPlanLimit": "Você utilizou 3/3 das subcontas permitidas no seu plano atual.",
    "upgradeTime": "É hora de fazer um upgrade!",
    "upgradeHigher": "Faça upgrade para um plano superior para aceitar a transferência da subconta.",
    "browse": "Navegue pelos planos",
    "pendingTransferTitle": "Uma solicitação de transferência para essa subconta já está pendente.",
    "unableTransfer": "Não foi possível carregar a subconta para esta agência.",
    "unableEjectCancel": "Não foi possível cancelar a solicitação de remoção da subconta.",
    "EjectErrorDetails": "A solicitação de remoção da subconta não pode ser cancelada.",
    "hippaErrorDescription": "Esta subconta está habilitada para HIPAA e não pode ser transferida para uma agência não HIPAA.",
    "pendingTransferErrorDescription": "Cancele o pedido de transferência existente para esta subconta antes de criar um novo.",
    "receivingAgency": "Agência de recebimento",
    "releasingAgency": "Agência de liberação",
    "noOfContacts": "Total de contatos",
    "requestedDate": "Data solicitada",
    "action": "Ação",
    "cancelTransfer": "Cancelar transferência",
    "decline": "Rejeitar",
    "cancelTransferRequest": "Cancelar a solicitação de transferência de subconta?",
    "cancelEjectRequest": "Cancelar a solicitação de ejeção da subconta?",
    "cancelRequestDescription": "A agência recebedora não verá mais esta solicitação de transferência, e a subconta {name} não será transferida.",
    "cancelEjectRequestDescription": "O usuário selecionado não poderá mais criar uma nova agência a partir da subconta {name}.",
    "declineRequest": "Recusar pedido de transferência de subconta?",
    "declineRequestDescription": "A solicitação será recusada e a subconta {name} não será transferida para a sua agência.",
    "approveTransfer": "Aprovar a transferência de subconta para sua agência?",
    "approveTransferDescription": "A subconta {name} será transferida para a sua agência.",
    "transferNow": "Transferir agora",
    "cancelNow": "Cancele agora",
    "transferErrorDetails": "Esta subconta não pode ser transferida.",
    "cancelRequest": "Cancelar solicitação",
    "received": "Recebido",
    "approve": "Aprovar",
    "goBack": "Voltar",
    "done": "Concluído",
    "subAccountTransferred": "A subconta foi transferida com sucesso!",
    "subAccountTransferDescription": "Mesmo que a subconta tenha sido transferida, alguns ativos como usuários, números de telefone, contas do Mailgun e listagens do Yext ainda podem levar de 10 a 15 minutos para serem refletidos no destino.",
    "activeSubscriptionsAlert": "A localização tem Dinâmico Assinatura. Cancele todos Assinatura antes da transferência fria a localização. Lista de dinâmica Assinatura: {subscriptions}",
    "isSaasEnabled": "SaaS habilitado",
    "typeToSearch": "Digite para pesquisar",
    "dateAdded": "Data de adição",
    "emailEngagement": "Engajamento de e-mail",
    "emailReaction": "Reação de e-mail",
    "emailDeliverySummary": "Resumo da entrega de e-mail",
    "facebook": "Facebook",
    "sms": "SMS",
    "instagram": "Instagram",
    "accountSummarySubAccount": "Resumo da conta - {subAccountName}",
    "test": "Testar",
    "scheduleExists": "A programação existe",
    "aToZ": "A - Z",
    "zToA": "Z - A",
    "onlyAdminUsersCanAddNewSubAccounts": "Somente usuários administradores podem incluir novas subcontas.",
    "locationName": "Nome da localização",
    "transferCompleted": "A solicitação de transferência para esta localização já foi processada. Atualize a página.",
    "unauthorizedTransfer": "Você não está autorizado a executar esta ação. Somente proprietários de agência podem executar esta Ação.",
    "bulkLocationTransfer": "Transferir subcontas em massa",
    "singleRequest": "Solicitação única",
    "bulkRequest": "Solicitação em massa",
    "backToLocationTransfer": "Voltar para a transferência de localização",
    "initiateBulkTransfer": "Iniciar transferência em massa de subcontas",
    "initiateBulkTransferDescription": "Selecione as subcontas que deseja transferir ou insira os IDs delas separados por vírgulas.",
    "subAccountId": "ID da subconta",
    "selectFromList": "Selecionar da lista",
    "addManually": "Adicionar manualmente",
    "accountsSelected": "{count} selecionada(s)",
    "selectAllSubAccounts": "selecionar todos",
    "removeAll": "Remover tudo",
    "addManualLocations": "Adicione IDs de localização separados por vírgulas",
    "manualAllLocationIds": "IDs de localização da subconta Você deseja transferência, Separado Via vírgulas.",
    "enterLocationIds": "Insira os IDs de localização",
    "selectSubAccounts": "Selecionar subcontas e transferir para uma agência existente",
    "subAccountTransferWarning": "todos os ativos subcontas e o usuário obterão o Baixar.",
    "proceed": "Prosseguir",
    "bulkRequestSubmitted": "Solicitação de transferência em massa enviada",
    "bulkRequestSubmittedDescription": "Cada subconta será transferida assim que a agência destinatária aceitar a solicitação de transferência. Você pode acompanhar o status da solicitação na página ❝{pagename}❞. (desde que sejam elegíveis)",
    "bulkTransferRequestFailed": "Solicitação de transferência em massa falhou",
    "errorLocations": "Subcontas com erro",
    "viewDetails": "Visualizar detalhes",
    "somethingWrong": "Algo deu errado. Tente novamente.",
    "confirmBulkRequest": "Confirmar solicitação de transferência em massa?",
    "bulkTransferAccounts": "Transferência em massa de '{count}' subcontas selecionadas?",
    "confirmDetails": "Confirme os detalhes antes de transferir.",
    "transferConsent": "Eu tenho a Ler e entender o guia acima e o consentimento para todas as limitações.",
    "transferInfo": "A transferência da subconta depende de a agência destinatária aceitá-la na conta dela.",
    "receivingRelNo": "Número de relacionamento da agência destinatária",
    "enterRelNo": "Insira o número de relacionamento",
    "transferConfirmation": "Após a finalização desta Ação, as Em massa Transferir Solicitações serão enviadas para a Agência Recebida ({ relNo }). todos a subconta Você've selecionado será Baixar assim que a agência recebida o aceitar. Observe que esta ação é irreversível para todas as subcontas incluídos in Transferir.",
    "confirmPassword": "Confirme Via password abaixo",
    "enterPassword": "Insira a senha",
    "requestTransfer": "Solicitar transferência",
    "confirmTransfer": "Confirmar transferência",
    "notNow": "Agora não",
    "invalidRelNo": "Número de relação inválido",
    "invalidPassword": "password inválida .",
    "searchSubAccounts": "Pesquisar subcontas",
    "searchSubAccountsId": "Pesquisar ID de subconta",
    "takeAction": "Agir agora",
    "sub_account_details": "Detalhes da subconta",
    "no_of_contacts": "Total de contatos",
    "transfer_status": "Status de transferência",
    "error_info": "Informações do erro",
    "bulk_transfer_status": "Status de transferência de subcontas em massa",
    "pending": "Pendente",
    "processed": "Processado",
    "reject_all": "Rejeitar tudo",
    "accept_all": "Aceitar tudo",
    "cancel_all": "Cancelar tudo",
    "clearAll": "Limpar tudo",
    "refresh": "Atualizar",
    "rejected": "Negado",
    "decline_transfer": "Recusar transferência",
    "decline_bulk_transfer": "Deseja recusar a solicitação de transferência de subcontas em massa?",
    "decline_bulk_transfer_description": "O pedido será recusado e as {length} subcontas não serão transferidas para a sua agência.",
    "accept_bulk_transfer": "Aceitar a solicitação de transferência em massa de subconta?",
    "accept_bulk_transfer_description": "O pedido será aceito e as subcontas {length} serão transferidas para a sua agência.",
    "cancel_bulk_transfer": "Cancelar transferência em massa?",
    "cancel_bulk_transfer_description": "Tem certeza de que deseja cancelar esta transferência em massa de {length} subcontas para “{name}”?",
    "consent_sub_account_transfer": "Ler e consentimento para {link}",
    "sub_account_transfer_guidelines": "Diretrizes para transferência de subconta",
    "valid_rel": "Insira um número de proporção válido",
    "something_went_wrong": "Algo deu errado. Tente novamente.",
    "export": "Exportar",
    "export_success": "Os dados que Você solicitado estão sendo processados. Você enviará um e-mail com os dados in alguns dados.",
    "export_failed": "Os dados Você solicitado não podem ser processados. Tente de novo mais tarde.",
    "selectAllError": "Você só pode selecionar 1.000 subcontas por vez.",
    "max1000": "(Máx. 1.000)",
    "subAccountCount": "Contagem de subcontas",
    "whatsapp": "WhatsApp",
    "scheduleBulkPauseConfirm": "Tem certeza de que deseja pausar {count} relatórios?",
    "scheduleBulkResumeConfirm": "Tem certeza de que deseja continuar {count} relatórios?",
    "resume": "Continuar",
    "pause": "Pausar",
    "resumeSelected": "Continuar selecionado",
    "pauseSelected": "Pausar selecionado",
    "bulkActions": "Bulk actions",
    "xReportsSelected": "{count} relatórios selecionados",
    "selectAllXReports": "Selecione todos os relatórios ({count})",
    "scheduleStatus": "Status da programação",
    "scheduleSearchPlaceholder": "Pesquisar usando e-mail ou nome da localização",
    "subAccountsPerPage": "Subcontas por página",
    "previous": "Anterior",
    "scheduleBulkAction": "Programar ação em massa",
    "all": "Todos",
    "active": "Ativo",
    "paused": "Pausado",
    "scheduleUpdatedSuccessfully": "programação atualizada com sucesso",
    "saveChanges": "Salvar alterações",
    "pauseSchedulesTitle": "Relatórios do Pausar Ativo Programado",
    "pauseSchedulesDescription": "clicar para Pausar agora relatórios Ativo.",
    "pauseSchedulesAlert": "Isso só afetará a Conta que é agora Dinâmico.",
    "pauseAllSchedulesBtnText": "Pausar todos os relatórios agendados",
    "autoScheduleTitle": "Programação automática para novas contas",
    "autoScheduleLabel": "Crie automaticamente relatórios agendados quando uma nova subconta for adicionada.",
    "autoScheduleAlert": "Desabilitar este Se Você deseja configurar manualmente para nova Conta.",
    "autoScheduleEnabledForNewAccounts": "Programação automática habilitada para nova Conta",
    "autoScheduleDisabledForNewAccounts": "Auto-programação desabilitado para nova Conta",
    "deleted": "Apagado",
    "locationPaused": "Localização em pausa",
    "scheduleSettingsModalTitle": "configurações do relatório de programação",
    "selectAllSchedules": "selecionar todos Programar",
    "selectScheduleForLocation": "Selecionar a programação para {location}",
    "openSettings": "Configurações abertas",
    "resumeScheduleForLocation": "Continuar programação para {location}",
    "pauseScheduleForLocation": "Pausar programação para {location}",
    "actions": "Ações",
    "deselectAll": "Desselecionar todos",
    "scheduleBulkActionResumeSuccess": "Em ativação de massa in andamento — Espera Desabilitado Ativado novas atividades",
    "scheduleBulkActionPauseSuccess": "Pausando relatórios — aguarde antes de realizar mais ações",
    "bulkActionCreationError": "Outra ação em massa está em andamento. Tente novamente em instantes.",
    "bulkActionInProgress": "Em massa Ação já in andamento",
    "scheduledReports": "Relatórios Programado",
    "scheduleBulkActionCompleted": "Em massa Ação concluída com sucesso",
    "pauseAllSchedulesModalTitle": "Pausar relatórios?",
    "pauseAllSchedulesModalText": "Isso irá pausar todos os relatórios agendados ativos em todas as subcontas.",
    "addLocationIdsPlaceholder": "Adicione os IDs de localização que deseja transferir...",
    "helloWorld": {
      "count": "A contagem é {count}",
      "editIntro": "Editar",
      "editAction": "Para testar o HMR",
      "checkOut": "Confira",
      "officialStarter": ", a versão inicial oficial do Vue + Vite",
      "install": "Instalar",
      "installDescription": "Em seu IDE para obter um DX melhor",
      "learnMore": "Clique nos logotipos da Vite e da Vue para saber mais"
    },
    "home": {
      "testMessage": "Olá! Esta é a página inicial do teste!"
    },
    "reports": {
      "incoming": "Recebidas",
      "outgoing": "Feitas",
      "duration": "Duração",
      "contactsCount": "Total de contatos",
      "appointmentsCount": "Total de compromissos",
      "formSubmissions": "Envios de formulários",
      "surveySubmissions": "Envio de pesquisas",
      "facebookFormSubmissions": "Envios de formulários do Facebook",
      "funnels": "Funis",
      "websites": "Sites",
      "forms": "Formulários",
      "surveys": "Pesquisas",
      "gbpMessages": "Mensagens GBP",
      "facebookMessages": "Mensagens do Facebook",
      "instagramMessages": "Mensagens do Instagram",
      "reviews": "Avaliações",
      "positives": "Positivos",
      "negatives": "Negativos"
    },
    "timeOptions": {
      "00": "00:00",
      "01": "1h",
      "02": "2h",
      "03": "3h",
      "04": "4h",
      "05": "5h",
      "06": "6h",
      "07": "7h",
      "08": "8h",
      "09": "9h",
      "10": "10h",
      "11": "11h",
      "12": "12h (meio-dia)",
      "13": "13h",
      "14": "14h",
      "15": "15h",
      "16": "16h",
      "17": "17h",
      "18": "18h",
      "19": "19h",
      "20": "20h",
      "21": "21h",
      "22": "22h",
      "23": "23h"
    },
    "transferStatus": {
      "pending": "Pendente",
      "processed": "Processado",
      "canceled": "Cancelado",
      "cancelled": "Cancelado",
      "completed": "Concluído",
      "rejected": "Rejeitado",
      "failed": "Falhou",
      "payment_pending": "Pagamento pendente"
    }
    }
